<script>
const Status = (status, tip) => ({
  render(h) {
    return h(
      "div",
      {
        style: {
          margin: "0 auto",
          width: "fit-content",
          alignItems: "center",
          display: "flex"
        }
      },
      [
        h("i", {
          class: `el-icon-${status}`,
          style: {
            fontSize: "24px",
            color: "#409EFF"
          }
        }),
        h(
          "span",
          {
            style: {
              color: "#409EFF",
              marginLeft: "5px"
            }
          },
          status === "loading"
            ? "加载组件中..."
            : status === "error"
            ? "加载失败,请检查路径"
            : tip || status
        )
      ]
    );
  }
});

export default {
  name: "customModal",
  emits: ["submit", "cancel", "error", "success"],
  props: {
    title: {
      type: String,
      default: ""
    },
    path: {
      type: String
    },
    footer: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      dialogVisible: false,
      component: Status("loading"),
      loading: false,
      modalTitle: "",
      Path: null
    };
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.$refs.instance && this.$refs.instance.submit) {
        this.$refs.instance.submit();
      } else {
        this.success();
      }
      this.$emit("submit");
    },
    cancel() {
      this.loading = false;
      this.$emit("cancel");
    },
    success() {
      this.loading = false;
      this.dialogVisible = false;
      this.$emit("success");
    },
    error() {
      this.loading = false;
      this.dialogVisible = true;
      this.$emit("error");
    },
    /**
     *
     * @param title 标题
     * @param path 路径
     */
    async open(title, path) {
      this.modalTitle = title || this.title;
      this.Path = path || this.path;
      this.dialogVisible = true;
      if (!this.Path) {
        this.component = Status("s-promotion", "没有路径");
        return;
      }
      try {
        const { default: DEFAULT } = await import(`@/${this.Path}.vue`);
        this.component = DEFAULT;
      } catch (err) {
        this.component = Status("error");
      }
    }
  }
};
</script>

<template>
  <!-- 用户表单对话框 -->
  <el-dialog
    :visible.sync="dialogVisible"
    :title="modalTitle"
    destroy-on-close
    v-bind="$attrs"
    @close="cancel"
    append-to-body
  >
    <template v-if="dialogVisible">
      <slot v-if="$slots.default"></slot>
      <component
        v-else
        ref="instance"
        @submit="submit"
        @cancel="cancel"
        @success="success"
        @error="error"
        :is="component"
      />
    </template>

    <template #footer v-if="footer">
      <slot name="footer">
        <span class="dialog-footer">
          <el-button
            v-if="showCancelButton"
            @click="dialogVisible = false"
            :loading="loading"
            >取消</el-button
          >
          <el-button type="primary" @click="submit" :loading="loading">
            确定
          </el-button>
        </span>
      </slot>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
